import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Lock, LogIn, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_33ee5137-3a8d-4e87-85d8-2bf18f119464/artifacts/go05yinq_solar%20icon%202.png";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false && user !== null) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div
      className="min-h-screen bg-[#001B33] flex items-center justify-center px-4"
      style={{ fontFamily: "Montserrat, sans-serif" }}
      data-testid="admin-login-root"
    >
      <div className="w-full max-w-md">
        <Link
          to="/"
          data-testid="back-to-quiz-link"
          className="inline-flex items-center gap-2 text-white/60 hover:text-[#FF8800] text-sm font-semibold mb-6 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Back to quiz
        </Link>
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10 border border-slate-100">
          <div className="flex flex-col items-center text-center">
            <img src={LOGO_URL} alt="logo" className="h-16 w-16" />
            <div className="mt-4 h-1 w-12 bg-[#FF8800] rounded-full" />
          </div>

          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <label className="block">
              <span className="block text-xs font-semibold text-[#001B33] mb-2 uppercase tracking-wider">
                Email
              </span>
              <input
                data-testid="admin-login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full border-2 border-slate-200 rounded-lg p-3 text-base font-medium focus:border-[#FF8800] focus:ring-1 focus:ring-[#FF8800] transition-colors outline-none"
              />
            </label>
            <label className="block">
              <span className="block text-xs font-semibold text-[#001B33] mb-2 uppercase tracking-wider">
                Password
              </span>
              <div className="relative">
                <input
                  data-testid="admin-login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  className="w-full border-2 border-slate-200 rounded-lg p-3 pl-10 text-base font-medium focus:border-[#FF8800] focus:ring-1 focus:ring-[#FF8800] transition-colors outline-none"
                />
                <Lock className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              </div>
            </label>

            {error && (
              <p
                data-testid="admin-login-error"
                className="text-sm font-semibold text-red-600"
              >
                {error}
              </p>
            )}

            <button
              data-testid="admin-login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-[#FF8800] hover:bg-[#E67A00] disabled:opacity-60 text-white font-semibold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all active:scale-[0.99] flex justify-center items-center gap-2"
            >
              {loading ? "Signing in…" : (
                <>
                  Sign In <LogIn className="h-4 w-4" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
